<div class="btn-group" dropdown  style="width: 100%; margin-top: -4px;" >
  <div class="dropdown-toggle base" dropdownToggle attr.aria-controls="dropdown-{{id}}" [ngClass]="{'form-grey': fondo, 'error-input': error}">
      <div *ngIf="listData !== null" class="content">
          <div class="content" *ngIf="listData.length > 0">
              {{ valueText }}
          </div>
          <div class="" *ngIf="listData.length == 0">
              <fa-icon icon="spinner" [spin]="true"></fa-icon> {{ loadText }}
          </div>
      </div>
      <div class="content" *ngIf="listData == null">
          N/A
      </div>
  </div>
  <ul id="dropdown-{{id}}" *dropdownMenu class="dropdown-menu" [ngClass]="{'form-grey': fondo, 'widthSelect': widthSelect, 'heightSelect': heightSelect}"
          role="menu" aria-labelledby="button-basic">
      <li role="menuitem" *ngIf="search">
          <div style="padding: 0 10px 10px;">
              <input (click)="clickInput($event)" name="buscar" [(ngModel)]="textSearch" type="text" class="form-control" placeholder="{{ 'globals.search' }}" autocomplete="off">
          </div>
      </li>
      <li *ngIf="!textSearch && listData !== null" role="menuitem" style="cursor: pointer" (click)=selectItem()>
          <a class="dropdown-item">
              {{ etiqueta.select }}
          </a>
      </li>
      <li *ngIf="!textSearch && listData == null" role="menuitem" style="cursor: pointer">
          <a class="dropdown-item">
              N/A
          </a>
      </li>
      <li role="menuitem" style="cursor: pointer" *ngFor="let list of listData | search:textSearch:modulo" (click)=selectItem(list) >
          <a class="dropdown-item content">
              {{ viewList(list) }}
          </a>
      </li>
  </ul>
</div>
